// extracted by mini-css-extract-plugin
var _1 = "ra-tabs-accordion";
var _2 = "ra-tabs-accordion-icon";
var _3 = "ra-tabs-accordion-row";
var _4 = "ra-tabs-content-active";
var _5 = "ra-tabs-content";
var _6 = "ra-tabs-tab-active";
var _7 = "ra-tabs-tab";
var _8 = "ra-tabs-tab-disabled";
var _9 = "ra-tabs-tab-icon";
var _a = "ra-tabs-tab-title";
var _b = "ra-tabs-side";
export { _1 as "tabsAccordionCls", _2 as "tabsAccordionIconCls", _3 as "tabsAccordionRowCls", _4 as "tabsContentActiveCls", _5 as "tabsContentCls", _6 as "tabsItemActiveCls", _7 as "tabsItemCls", _8 as "tabsItemDisabledCls", _9 as "tabsItemIconCls", _a as "tabsItemTitleCls", _b as "tabsSideCls" }
